import axios from "axios";
import { store } from "../store";

const apiUrl = process.env.REACT_APP_API_URL;

// Create axios instance
const apiClient = axios.create({
  baseURL: apiUrl,
});

// Request interceptor to add authorization header
apiClient.interceptors.request.use(
  (config) => {
    const token = store.getState().user.token || localStorage?.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle all status codes
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Return the error response object instead of throwing
    return error.response || error;
  },
);

export const get = async (url: string) => {
  return await apiClient.get(url);
};

export const post = async (url: string, payload: any) => {
  return await apiClient.post(url, payload);
};

export const put = async (url: string, payload: any) => {
  return await apiClient.put(url, payload);
};

export const del = async (url: string) => {
  return await apiClient.delete(url);
};
